/**
 * Coming Soon placeholder for features not yet implemented.
 * Used for Master Daily, Master Summary, and similar roadmap items.
 */
import React from 'react';
import { Card } from 'react-bootstrap';

const ComingSoon = ({ title, message, roadmap }) => {
  const defaultMessage = 'This feature is planned for a future release.';
  const defaultRoadmap = [
    'Consolidated daily view across project areas',
    'Export and reporting options',
    'Integration with Master Budget'
  ];

  return (
    <div className="container py-5">
      <Card className="shadow-sm border-0 bg-dark bg-opacity-25 text-center">
        <Card.Body className="p-5">
          <Card.Title as="h3" className="mb-3 text-light">
            {title || 'Coming Soon'}
          </Card.Title>
          <Card.Text className="text-white-50 mb-4">
            {message || defaultMessage}
          </Card.Text>
          {(roadmap || defaultRoadmap).length > 0 && (
            <>
              <Card.Text className="text-white-50 small text-uppercase mb-2">
                Planned
              </Card.Text>
              <ul className="list-unstyled text-white-50 mb-0">
                {(roadmap || defaultRoadmap).map((item, i) => (
                  <li key={i} className="mb-1">• {item}</li>
                ))}
              </ul>
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default ComingSoon;
